import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import _ from 'lodash';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { getBytesLength } from '@root/util/util';

@Component({
  selector: 'host-duplicate-guest',
  templateUrl: './duplicate-guest.component.html',
  styleUrls: ['./duplicate-guest.component.scss']
})
export class DuplicateGuestComponent implements OnInit {
  private readonly guestListApi = '/api/client/list';

  form: FormGroup = this.fb.group({
    name: '',
    phone: '',
    email: '',
    id_number: ''
  })

  listOfGuest = [];
  @Input() guestInfo = null;

  @Output() onClickExistGuest = new EventEmitter<any>();
  @Output() onClickCreateGuest = new EventEmitter<any>();

  private compositionFlag = false;

  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private modalRef: NzModalRef
  ) { }

  ngOnInit() {
    if (this.guestInfo) {
      this.form.patchValue(this.guestInfo);
      this.fetchGuestList();
    }
    // this.fetchGuestList();
  }

  compositionstart (control) {
    this.compositionFlag = true;
  }
  compositionend (control) {
    this.compositionFlag = false;
    this.checkDuplicateGuests(control);
  }

  checkDuplicateGuests (control) {
    if (this.compositionFlag) {
      return;
    }
    const value = this.form.value;
    const limit = control === 'phone' ? 5 : 3;
    if (value[control] && getBytesLength(value[control]) >= limit) {
      this.fetchGuestList();
    }

    if (!value.name && !value.phone && !value.email && !value.id_number) {
      this.listOfGuest = [];
    }
  }

  fetchGuestList () {
    const value = this.form.value;
    const query = new HttpParams({
      fromObject: {
        page: '1',
        page_size: '20',
        format: 'reservation_add_client',
        search_arr: `${value.name || ''},${value.phone || ''},${value.email || ''},${value.id_number || ''}`
      }
    })
    this.http.get(this.guestListApi, { params: query}).subscribe(res => {
      this.listOfGuest = _.get(res, 'data.list') || [];
    });
  }

  clickCreateGuest() {
    this.modalRef.destroy({
      type: 'onClickCreateGuest',
      data: this.form.value
    });

    this.onClickCreateGuest.emit(this.form.value);
    // this.onClickCreateGuest.emit(this.form.value);
  }

  clickExistGuest (guest) {
    this.modalRef.destroy({
      type: 'onClickExistGuest',
      data: guest
    });

    this.onClickExistGuest.emit(guest);
  }
}
